import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

import contactBG from '../../assets/img/contact/bg-5-1.jpg';

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', formRef.current, {
        publicKey: 'YOUR_PUBLIC_KEY',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
  };

  return (
    <div
      id="it-contact"
      className="it-contact-area it-contact-style-3 p-relative z-index grey-bg-2 pt-190 pb-140"
      style={{ backgroundImage: `url(${contactBG})` }}
    >
      <div className="it-contact-p p-relative">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6">
              <div className="it-contact-left">
                <div className="it-contact-title-box mb-20">
                  <h3 className="it-section-title text-white">
                    Prevention is better <br />
                    than cure
                  </h3>
                </div>
                <div className="it-contact-text">
                  <p className="mb-0 text-white">
                    Many desktop publishing packages and web page editors now
                    use Lorem Ipsum as their default model text, and a search
                    for 'lorem ipsum' will uncover.Many deskto
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="it-contact-from-wrap z-index">
                <div className="it-contact-title-box mb-50">
                  <span className="it-section-subtitle red-border">
                    Why choose Us?
                  </span>
                  <h3 className="it-section-title d-block">
                    Online Consultant To <br /> The Patient.
                  </h3>
                </div>

                <form ref={formRef} onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Name" />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="email" placeholder="E-mail" />
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Subject" />
                      </div>
                    </div>
                    <div className="col-12 mb-30">
                      <div className="it-contact-input-box">
                        <textarea placeholder="Comment"></textarea>
                      </div>
                    </div>
                  </div>
                  <button type="button" className="it-btn-theme red-bg mr-35">
                    <span className="btn-wrap">
                      <span className="text-one">
                        Submit Now
                        <i>
                          <svg
                            width="34"
                            height="12"
                            viewBox="0 0 34 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M32.4512 6.67971H0.683183C0.305297 6.67971 0 6.37442 0 5.99653C0 5.61865 0.305297 5.31335 0.683183 5.31335H30.8009L26.6548 1.16728C26.3879 0.900413 26.3879 0.46702 26.6548 0.200151C26.9217 -0.0667171 27.3551 -0.0667171 27.6219 0.200151L32.9358 5.51403C33.1322 5.71045 33.1899 6.00294 33.0831 6.25913C32.9764 6.51319 32.7266 6.67971 32.4512 6.67971Z"
                              fill="currentcolor"
                            />
                            <path
                              d="M27.1309 12C26.9558 12 26.7808 11.9338 26.6484 11.7993C26.3815 11.5325 26.3815 11.0991 26.6484 10.8322L31.9687 5.51192C32.2355 5.24505 32.6689 5.24505 32.9358 5.51192C33.2027 5.77879 33.2027 6.21218 32.9358 6.47905L27.6155 11.7993C27.481 11.9338 27.306 12 27.1309 12Z"
                              fill="currentcolor"
                            />
                          </svg>
                        </i>
                      </span>
                      <span className="text-two">
                        Submit Now
                        <i>
                          <svg
                            width="34"
                            height="12"
                            viewBox="0 0 34 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M32.4512 6.67971H0.683183C0.305297 6.67971 0 6.37442 0 5.99653C0 5.61865 0.305297 5.31335 0.683183 5.31335H30.8009L26.6548 1.16728C26.3879 0.900413 26.3879 0.46702 26.6548 0.200151C26.9217 -0.0667171 27.3551 -0.0667171 27.6219 0.200151L32.9358 5.51403C33.1322 5.71045 33.1899 6.00294 33.0831 6.25913C32.9764 6.51319 32.7266 6.67971 32.4512 6.67971Z"
                              fill="currentcolor"
                            />
                            <path
                              d="M27.1309 12C26.9558 12 26.7808 11.9338 26.6484 11.7993C26.3815 11.5325 26.3815 11.0991 26.6484 10.8322L31.9687 5.51192C32.2355 5.24505 32.6689 5.24505 32.9358 5.51192C33.2027 5.77879 33.2027 6.21218 32.9358 6.47905L27.6155 11.7993C27.481 11.9338 27.306 12 27.1309 12Z"
                              fill="currentcolor"
                            />
                          </svg>
                        </i>
                      </span>
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-8 col-lg-8">
              <div className="it-contact-tel-wrap">
                <div className="it-contact-tel-box d-flex align-items-center mb-40">
                  <div className="it-contact-tel-icon">
                    <span>
                      <i className="flaticon-email"></i>
                    </span>
                  </div>
                  <div className="it-contact-tel-text">
                    <a href="mailto:contact@website">
                      Main Email : contact@website
                    </a>
                    <a href="mailto:Info@mail.com">
                      ComInquiries : Info@mail.com
                    </a>
                  </div>
                </div>
                <div className="it-contact-tel-box d-flex align-items-center">
                  <div className="it-contact-tel-icon">
                    <span>
                      <i className="flaticon-call"></i>
                    </span>
                  </div>
                  <div className="it-contact-tel-text">
                    <a href="tel:0025894585">Telephone : 00258 94585</a>
                    <a href="tel:000185538456"> Mobile : 000 1855 38456</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="it-contact-bg"></div>
      </div>
    </div>
  );
};

export default Contact;
